(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMobileMegaMenuAnimation() {
      const drawer = document.querySelector('#menu-drawer');

      if (!drawer || drawer.dataset.smoothMenuInitialized === 'true') {
        return;
      }

      drawer.dataset.smoothMenuInitialized = 'true';

      const menuItems = drawer.querySelectorAll('.menu-drawer__navigation details');

      function animateMenu(details, shouldOpen) {
        const submenu = details.querySelector(':scope > .menu-drawer__submenu');

        if (!submenu) return;

        const startHeight = submenu.getBoundingClientRect().height;

        submenu.style.overflow = 'hidden';
        submenu.style.transition = 'none';
        submenu.style.height = startHeight + 'px';
        submenu.style.opacity = shouldOpen ? '0' : '1';

        if (shouldOpen) {
          details.open = true;
        }

        submenu.offsetHeight;

        requestAnimationFrame(() => {
          submenu.style.transition = 'height 700ms ease, opacity 450ms ease';

          if (shouldOpen) {
            submenu.style.height = submenu.scrollHeight + 'px';
            submenu.style.opacity = '1';
          } else {
            submenu.style.height = '0px';
            submenu.style.opacity = '0';
          }
        });

        let finished = false;

        function finishAnimation(event) {
          if (event && (event.target !== submenu || event.propertyName !== 'height')) {
            return;
          }

          if (finished) return;
          finished = true;

          submenu.removeEventListener('transitionend', finishAnimation);

          if (shouldOpen) {
            submenu.style.height = 'auto';
            submenu.style.opacity = '1';
          } else {
            details.open = false;
            submenu.style.height = '0px';
            submenu.style.opacity = '0';
          }

          submenu.style.transition = 'none';
          details.dataset.animating = 'false';
        }

        details.dataset.animating = 'true';

        submenu.addEventListener('transitionend', finishAnimation);

        setTimeout(() => {
          finishAnimation();
        }, 800);
      }

      menuItems.forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        const submenu = details.querySelector(':scope > .menu-drawer__submenu');

        if (!summary || !submenu) return;

        details.dataset.animating = 'false';

        submenu.style.overflow = 'hidden';
        submenu.style.height = details.open ? 'auto' : '0px';
        submenu.style.opacity = details.open ? '1' : '0';
        submenu.style.transition = 'none';

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (details.dataset.animating === 'true') return;

          const shouldOpen = !details.open;

          if (shouldOpen) {
            // Close other open menus first
            menuItems.forEach((otherDetails) => {
              if (otherDetails !== details && otherDetails.open && otherDetails.dataset.animating !== 'true') {
                animateMenu(otherDetails, false);
              }
            });

            animateMenu(details, true);
          } else {
            animateMenu(details, false);
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileMegaMenuAnimation);
    } else {
      initMobileMegaMenuAnimation();
    }

    document.addEventListener('shopify:section:load', () => {
      const drawer = document.querySelector('#menu-drawer');

      if (drawer) {
        delete drawer.dataset.smoothMenuInitialized;
      }

      initMobileMegaMenuAnimation();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
